import vuetify from 'libs/vuetify';

export default {
  vuetify,
  data: {
    $el: $('#programs-listing'),
    programs: [],
    paginator: null,
    categories: [],
    selected_program: null,
    show_categories_modal: false,
    selected_categories: []

  },

  methods: {
    bindData: function (data) {
      this.programs = data.programs;
      this.paginator = data.paginator;
      this.categories = data.categories;
      self = this;
    },

    programListing: function(url_param, _currentPage) {
      const self = this;
      const url = url_param ? url_param : Kadenze.Routes.admin_programs_path();

      const request = new Kadenze.AjaxRequest({
        type: 'GET',
        url: url,
        loadingIndicator: {
          container: self.$el
        }
      });

      request.done((data) => {
        self.bindData(data);
      });

      request.fail((data) => {
        console.warn('error retrieving session data');
        console.log(data);

        new Kadenze.Notice.error({
          message: 'There was a problem loading Programs, please contact system administrators'
        });
      });

      request.always((_xhr, _textStatus) => {
        Kadenze.PaginationBinding.applyBindingsWithTextInput(self.programListing);
      });
    },

    downloadUsers: function(program) {
      const self = this;
      const url = Kadenze.Routes.download_enrollments_admin_program_path(program.id);
      const method = 'POST';
      const downloadPrompt = 'CSV file will be emailed to you when your user list is complete';

      Kadenze.UIUtil.confirmAction(downloadPrompt, function() {
        const request = new Kadenze.AjaxRequest({
          url: url,
          method: method,
          data: {program: {id: program.id}},
          loadingIndicator: {
            container: self.$el
          }
        });

        request.done(function(data) {
          new Kadenze.Notice.success({ message: data.message });
        });

        request.fail(function(xhr, _textStatus, _errorThrown) {
          new Kadenze.Notice.error({ message: xhr.responseJSON.message });
        });
      });
    },

    selectCategory: function(program) {
      self.selected_program = program;
      self.selected_categories = program.categories;
      self.show_categories_modal = true;
    },

    updateCateogoriesInProgram(id) {
      const value = _.find(self.programs, function(obj) {
        if(obj.id == id){
          obj.categories = self.selected_categories;
        }
      });
    },

    getIdsFromObjects(all_objects, selected_objects) {
      var ids = [];
      selected_objects.forEach(object=>{
        const id = object.id;
        ids.push(id);
      });

      return ids;
    },

    saveProgram(){
      self.show_categories_modal = false;
      var category_ids = self.getIdsFromObjects(self.categories, self.selected_categories)
      var request = new Kadenze.AjaxRequest({
        type: 'PATCH',
        url: Kadenze.Routes.admin_program_path(self.selected_program.id),
        data: { program: { category_ids: category_ids } }
      });

      request.done(function(data) {
        self.updateCateogoriesInProgram(data.program.id);
        new Kadenze.Notice.success({ message: data.message });
      });

      request.fail(function(data) {
        new Kadenze.Notice.error({ message: data.message });
      });
    },

    program_logo_url(program) {
      return program.card_image;
    },

    is_draft(status) {
      status == 'draft';
    },

    is_published(status) {
      status == 'published';
    }
  },

  mounted: function() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(this.programListing);
  }
};